import LoginPage from './login.vue';
import OpenIdLoginPage from './login-openid.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    id: 'login',
    component: LoginPage,
    meta: { hideNavbar: true, title: 'Login' },
    omitFromNav: true,
  },
  // Allow specific navigation to each login page, while /login will use the component of the configured default
  {
    path: '/auth-openid/login',
    name: 'auth-openid/login',
    id: 'auth-openid/login',
    component: OpenIdLoginPage,
    meta: { hideNavbar: true },
    omitFromNav: true,
  },
];

export default routes;
